export const communeModel = {
    label: 'Commune',
    tableName: 'commune',
    properties: [
        {
            label: 'District',
            id: 'district',
            isForeignKey: true,
            column_name: 'name',
            table_column: 'parent',
            type: 'text',
            example: 'Antsiranana I',
            required: true
        },
        {
            label: 'Nom',
            id: 'name',
            type: 'text',
            example: 'Antanamitarana',
            required: true
        }
    ]
}
